export default __webpack_public_path__ + "static/media/money.76196f5e.svg";